"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPortalSupportedLocalization = exports.languagesByPortalPortalSupported = exports.landingSupportedLanguages = exports.portalSupportedLanguages = void 0;
const constants_1 = require("./constants");
const locale_to_iso_1 = require("./lib/locale-to-iso");
const switch_key_value_in_object_1 = require("./lib/switch-key-value-in-object");
exports.portalSupportedLanguages = Object.entries(constants_1.languages).map(([, locale]) => locale);
exports.landingSupportedLanguages = Object.entries(constants_1.languages).map(([locale, _]) => locale);
exports.languagesByPortalPortalSupported = (0, switch_key_value_in_object_1.switchKeyValueInObj)(constants_1.languages);
const getPortalSupportedLocalization = (locale) => {
    const { localeCode, alphabetCode, countryCode } = (0, locale_to_iso_1.localeToISO)(locale);
    let code = [localeCode, alphabetCode, countryCode].filter(Boolean).join('-');
    let cycleProtectionCounter = 0;
    const maxIterations = 5;
    while (code.length > 0 && cycleProtectionCounter < maxIterations) {
        if (exports.portalSupportedLanguages.includes(code)) {
            return code;
        }
        if (!code.includes('-')) {
            break;
        }
        cycleProtectionCounter++;
        code = removeLastLocalePart(code);
    }
    return constants_1.languages[constants_1.LOCALIZATION_FALLBACK];
};
exports.getPortalSupportedLocalization = getPortalSupportedLocalization;
const removeLastLocalePart = (code) => code.replace(/-\w+$/, '');
